import * as React from 'react';

import { Box, Typography } from '@mui/material';

import LoadingButton from '../../Button/LoadingButton';
import BaseDialog, { BaseDialogProps } from '../Base';

type ActionConfirmationDialogProps = {
  title?: string;
  description?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  isConfirmLoading?: boolean;
  cancelButtonText?: string;
  confirmButtonText?: string;
} & BaseDialogProps;

const ActionConfirmationDialog: React.FC<ActionConfirmationDialogProps> = ({
  title,
  description,
  onConfirm,
  onCancel,
  cancelButtonText,
  confirmButtonText,
  isConfirmLoading,
  ...restProps
}) => {
  return (
    <BaseDialog
      width='550px'
      height='164px'
      titleComponent={<></>}
      showCloseIcon={false}
      {...restProps}
    >
      <Box>
        {title && (
          <Typography textAlign={'center'} fontSize={'18px'} fontWeight={500}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography paddingTop={'34px'} paddingBottom={'44px'} textAlign={'center'}>
            {description}
          </Typography>
        )}

        <Box display={'flex'} alignItems={'center'} gap={'20px'} mt={4}>
          <LoadingButton
            fullWidth
            variant='outlined'
            size='large'
            sx={{ paddingY: '12px' }}
            onClick={onCancel}
          >
            {cancelButtonText || 'Cancel'}
          </LoadingButton>
          <LoadingButton
            fullWidth
            loading={isConfirmLoading}
            variant='contained'
            color='error'
            type='submit'
            size='large'
            sx={{
              paddingY: '12px',
            }}
            onClick={onConfirm}
          >
            {confirmButtonText || 'onConfirm'}
          </LoadingButton>
        </Box>
      </Box>
    </BaseDialog>
  );
};

export default ActionConfirmationDialog;
